export const GameStagesTypes = {
    ALL: {
        id: "ALL",
        title: "همه"
    },
    ACTIVE: {
        id: "ACTIVE",
        title: "فعال"
    },
    INACTIVE: {
        id: "INACTIVE",
        title: "غیر فعال"
    },
    ARCHIVED: {
        id: "ARCHIVED",
        title: "آرشیو"
    },
    DRAFT: {
        id: "DRAFT",
        title: "پیش نویس"
    }
}


export function getGameStagesStatus(status) {
    switch (status) {

        case GameStagesTypes.ACTIVE.id:{
            return GameStagesTypes.ACTIVE.title
        }
        case GameStagesTypes.INACTIVE.id:{
            return GameStagesTypes.INACTIVE.title
        }
        case GameStagesTypes.ARCHIVED.id:{
            return GameStagesTypes.ARCHIVED.title
        }
        case GameStagesTypes.DRAFT.id:{
            return GameStagesTypes.DRAFT.title
        }

    }
}